var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleDrive = function SvgGoogleDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-drive_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066DA",
    d: "m1.352 13.696.79 1.362c.163.287.399.512.675.676q1.188-1.508 1.655-2.315.473-.82 1.162-2.561-1.858-.245-2.817-.245-.92 0-2.817.245c0 .317.082.635.246.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M15.069 15.734c.276-.164.512-.39.676-.676l.328-.563 1.567-2.715c.16-.28.246-.598.246-.922q-1.91-.245-2.812-.245-.972 0-2.812.245.68 1.752 1.147 2.561.47.816 1.66 2.315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832D",
    d: "M8.942 5.122q1.376-1.66 1.895-2.56.42-.726.922-2.316A1.8 1.8 0 0 0 10.837 0h-3.79c-.328 0-.645.092-.922.246q.64 1.824 1.086 2.596.494.853 1.731 2.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684FC",
    d: "M12.251 10.86H5.634l-2.818 4.876a1.8 1.8 0 0 0 .922.245h10.409c.327 0 .645-.092.922-.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AC47",
    d: "M8.943 5.122 6.126.246a1.86 1.86 0 0 0-.676.676L.246 9.937c-.161.28-.246.599-.246.922h5.634z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA00",
    d: "M15.04 5.43 12.44.922a1.86 1.86 0 0 0-.677-.676L8.945 5.122l3.31 5.737h5.623c0-.317-.082-.635-.245-.922z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google-drive_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h17.888v16H0z"
  })))));
};
export default SvgGoogleDrive;